import { useContext } from "react";
import { DataTableContext } from "./DataTableContext";

const useDataTableContext = () => useContext(DataTableContext);

export default useDataTableContext;
